export const LAYOUT_PROFILE_IMAGE_ROUND = 0;
export const LAYOUT_PROFILE_IMAGE_SQUARE = 1;
